module.exports = __webpack_public_path__ + "img/download_13.65715200.png";